import {
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
} from '@mui/x-data-grid';
import TablePagination from '@mui/material/TablePagination';
import { MenuItem, Select, Stack } from '@mui/material';

export default function CustomPagination({
  isFetching,
}: {
  isFetching: boolean;
}) {
  const apiRef = useGridApiContext();

  const page = useGridSelector(apiRef, gridPageSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const pageCount = Math.ceil(rowCount / pageSize);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    apiRef.current.setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newPageSize = parseInt(event.target.value, 10);
    apiRef.current.setPageSize(newPageSize);
  };

  const handlePageSelectChange = (event: any) => {
    const newPage = parseInt(event.target.value, 10);
    apiRef.current.setPage(newPage);
  };

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      gap={2} // optional spacing between items
      paddingX={2}
    >
      <TablePagination
        component="div"
        count={rowCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={pageSize}
        labelRowsPerPage="" // Hides label
        rowsPerPageOptions={[]} // Hides dropdown
      />

      {/* Page selector dropdown */}
      {pageCount > 1 && (
        <Select
          size="small"
          value={page}
          onChange={handlePageSelectChange}
          sx={{ minWidth: 100, height: 30 }}
        >
          {Array.from({ length: pageCount }, (_, idx) => (
            <MenuItem key={idx} value={idx}>
              Page {idx + 1}
            </MenuItem>
          ))}
        </Select>
      )}
    </Stack>
  );
}
